/* Biowein Lenhart – theme behaviour (no dependencies) */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Overlays: menu + newsletter modal ---------- */
  let lastFocus = null;
  const openOverlay = (el) => {
    if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    const focusable = el.querySelector('button, a, input');
    if (focusable) focusable.focus();
  };
  const closeOverlay = (el) => {
    if (!el || el.hidden) return;
    el.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  };

  const menu = document.querySelector('[data-menu]');
  const modal = document.getElementById('NewsletterModal');

  document.addEventListener('click', (e) => {
    const t = e.target;
    if (t.closest('[data-menu-open]')) {
      openOverlay(menu);
      t.closest('[data-menu-open]').setAttribute('aria-expanded', 'true');
    } else if (t.closest('[data-menu-close]')) {
      closeOverlay(menu);
      document.querySelector('[data-menu-open]')?.setAttribute('aria-expanded', 'false');
    } else if (t.closest('[data-open-newsletter]')) {
      e.preventDefault();
      if (menu && !menu.hidden) closeOverlay(menu);
      openOverlay(modal);
    } else if (t.closest('[data-modal-close]')) {
      closeOverlay(t.closest('[data-modal]'));
    } else if (t.closest('[data-cart-toast-close]')) {
      document.querySelector('[data-cart-toast]').hidden = true;
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    closeOverlay(menu);
    closeOverlay(modal);
    closeOverlay(notice);
  });

  // Notice popup (home page): opens right away until its end date, once per browser session after closing.
  const notice = document.querySelector('[data-notice]');
  if (notice) {
    const key = `notice-closed-${notice.dataset.notice}`;
    let closed = false;
    try { closed = sessionStorage.getItem(key) === '1'; } catch (e) { /* private mode */ }
    if (!closed && Date.now() < Date.parse(notice.dataset.noticeEnd)) openOverlay(notice);
    notice.querySelectorAll('[data-modal-close]').forEach((el) => el.addEventListener('click', () => {
      try { sessionStorage.setItem(key, '1'); } catch (e) { /* private mode */ }
    }));
  }
  // Re-open the newsletter popup after a submit so the customer sees the result.
  const nlStore = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* private mode */ } },
  };
  if (modal && (location.search.includes('customer_posted=true') || location.hash === '#NewsletterForm')) {
    openOverlay(modal);
    if (modal.querySelector('[data-newsletter-success]')) nlStore.set('nl-subscribed', '1');
  }

  // Auto-open once per visitor (not again for 14 days after closing, never after subscribing).
  if (modal && modal.hasAttribute('data-newsletter-auto')) {
    const body = document.body.className;
    const skipPage = /template-(cart|password|customers|gift_card)|template-page--weinrad/.test(body);
    const dismissed = parseInt(nlStore.get('nl-dismissed') || '0', 10);
    const recently = Date.now() - dismissed < 14 * 864e5;
    if (!skipPage && !recently && !nlStore.get('nl-subscribed') && modal.hidden) {
      let done = false;
      const show = () => {
        if (done || !modal.hidden) return;
        if (menu && !menu.hidden) return;
        if (notice && !notice.hidden) return;
        done = true;
        window.removeEventListener('scroll', onScrollNl);
        openOverlay(modal);
      };
      const onScrollNl = () => {
        const max = document.documentElement.scrollHeight - window.innerHeight;
        if (max > 0 && window.scrollY / max > 0.5) show();
      };
      setTimeout(show, (parseInt(modal.dataset.delay, 10) || 12) * 1000);
      window.addEventListener('scroll', onScrollNl, { passive: true });
    }
    modal.querySelectorAll('[data-modal-close]').forEach((el) => el.addEventListener('click', () => {
      if (!modal.querySelector('[data-newsletter-success]')) nlStore.set('nl-dismissed', String(Date.now()));
    }));
  }

  /* ---------- Sticky header ---------- */
  const headerSection = document.querySelector('.section-header');
  if (headerSection) {
    const threshold = 160;
    let sticky = false;
    const onScroll = () => {
      const should = window.scrollY > threshold;
      if (should !== sticky) {
        sticky = should;
        headerSection.classList.toggle('is-sticky', sticky);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Scroll effects (Elementor motion FX replacement) ---------- */
  const fxEls = reduceMotion ? [] : [...document.querySelectorAll('[data-fx]')];
  if (fxEls.length && window.matchMedia('(min-width: 768px)').matches) {
    let ticking = false;
    const update = () => {
      const vh = window.innerHeight;
      fxEls.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        // progress: 0 when element enters from bottom, 1 when it leaves at top
        const progress = Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height)));
        if (el.dataset.fx === 'scale') {
          // "out-in": grows until the middle of the viewport, stays at 1
          const s = 0.8 + Math.min(1, progress * 2) * 0.2;
          el.style.transform = `scale(${s.toFixed(3)})`;
        } else if (el.dataset.fx === 'parallax') {
          const speed = parseFloat(el.dataset.speed || '2');
          el.style.transform = `translateY(${((0.5 - progress) * speed * 20).toFixed(1)}px)`;
        }
      });
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Cart: "Ich hole ab Hof ab" switch (adds/removes the pickup discount code, keeps other codes) ---------- */
  document.querySelectorAll('[data-pickup]').forEach((box) => {
    const toggle = box.querySelector('[data-pickup-toggle]');
    const code = box.dataset.pickupCode;
    // Shopify allows only one product discount per bottle: with a Weinrad code the pickup code is accepted but not applied.
    fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((r) => r.json()).then((cart) => {
      const entry = (cart.discount_codes || []).find((d) => d.code.toUpperCase() === code);
      if (!entry || entry.applicable) return;
      toggle.setAttribute('aria-checked', 'true');
      box.classList.add('is-on');
      const note = document.createElement('p');
      note.className = 'cart-pickup__hint';
      note.textContent = 'Mit dem Weinrad-Gewinn im Warenkorb gibt es den Ab-Hof-Preis bei dieser Bestellung leider nicht – deine Gratisflasche bleibt dir natürlich.';
      box.appendChild(note);
    });
    toggle.addEventListener('click', async () => {
      toggle.disabled = true;
      const on = toggle.getAttribute('aria-checked') !== 'true';
      toggle.setAttribute('aria-checked', String(on));
      box.classList.toggle('is-on', on);
      const root = window.Shopify?.routes?.root || '/';
      try {
        const cart = await (await fetch(`${root}cart.js`)).json();
        const others = (cart.discount_codes || []).map((d) => d.code).filter((c) => c.toUpperCase() !== code);
        const codes = on ? [...others, code] : others;
        await fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: codes.join(',') }),
        });
      } finally {
        window.location.reload();
      }
    });
  });

  /* ---------- Product carousel (infinite loop, autoplay, swipe) ---------- */
  document.querySelectorAll('[data-carousel]').forEach((viewport) => {
    const track = viewport.querySelector('[data-carousel-track]');
    const originals = [...track.children];
    if (originals.length < 2) return;
    // Clone enough slides for a seamless loop.
    originals.forEach((s) => track.appendChild(s.cloneNode(true)));
    let index = 0;
    const slideWidth = () => originals[0].getBoundingClientRect().width;
    const go = (i, animate = true) => {
      track.style.transition = animate ? '' : 'none';
      index = i;
      track.style.transform = `translateX(${-index * slideWidth()}px)`;
    };
    track.addEventListener('transitionend', () => {
      if (index >= originals.length) go(index - originals.length, false);
      if (index < 0) go(index + originals.length, false);
    });
    const delay = parseInt(viewport.dataset.autoplay || '0', 10) * 1000;
    let timer = null;
    const start = () => { if (delay && !reduceMotion) timer = setInterval(() => go(index + 1), delay); };
    const stop = () => clearInterval(timer);
    viewport.addEventListener('mouseenter', stop);
    viewport.addEventListener('mouseleave', start);
    let x0 = null;
    viewport.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    viewport.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) {
        if (dx < 0) go(index + 1);
        else { if (index === 0) go(originals.length, false); requestAnimationFrame(() => go(index - 1)); }
      }
      x0 = null; start();
    });
    window.addEventListener('resize', () => go(index, false));
    start();
  });

  /* ---------- AJAX add to cart ---------- */
  const toast = document.querySelector('[data-cart-toast]');
  let toastTimer = null;
  const renderShippingProgress = (cart) => {
    const b = document.body.dataset;
    const bottles = Math.floor((cart.total_weight || 0) / (parseFloat(b.bottleWeight) || 1300));
    const at = parseInt(b.freeAt || '6', 10);
    const de = parseInt(b.freeDe || '12', 10);
    const word = (n) => (n === 1 ? 'Flasche' : 'Flaschen');
    let msg;
    if (bottles === 0) msg = b.shippingDefault || '';
    else if (bottles < at) msg = `Noch ${at - bottles} ${word(at - bottles)} bis zum Gratisversand in Österreich`;
    else if (bottles < de) msg = `✓ Gratisversand in Österreich · nach Deutschland noch ${de - bottles} ${word(de - bottles)}`;
    else msg = '✓ Gratisversand nach Österreich und Deutschland';
    document.querySelectorAll('[data-shipping-msg]').forEach((el) => { el.textContent = msg; });
    document.querySelectorAll('[data-shipping-fill]').forEach((el) => { el.style.width = Math.min(100, (bottles / at) * 100) + '%'; });
  };
  const updateCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  };
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    const button = form.querySelector('[type="submit"]');
    button?.setAttribute('disabled', '');
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        alert(err.description || 'Das Produkt konnte nicht hinzugefügt werden.');
        return;
      }
      const cart = await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)).json();
      updateCount(cart.item_count);
      renderShippingProgress(cart);
      form.dispatchEvent(new CustomEvent('cart:added', { bubbles: true, detail: { cart } }));
      if (toast) {
        toast.hidden = false;
        clearTimeout(toastTimer);
        toastTimer = setTimeout(() => { toast.hidden = true; }, 5000);
      }
    } catch (err) {
      form.submit();
    } finally {
      button?.removeAttribute('disabled');
    }
  });

  /* ---------- Product recommendations ---------- */
  document.querySelectorAll('product-recommendations[data-url]').forEach(async (el) => {
    if (el.children.length) return;
    try {
      const html = await (await fetch(el.dataset.url)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('product-recommendations');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    } catch (err) { /* recommendations are optional */ }
  });

  /* ---------- Shop category tabs ---------- */
  document.querySelectorAll('[data-shop-filter]').forEach((nav) => {
    const grid = nav.parentElement.querySelector('[data-shop-grid]');
    if (!grid) return;
    const apply = (tag) => {
      nav.querySelectorAll('[data-filter]').forEach((b) => {
        const on = b.dataset.filter === tag;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on);
      });
      grid.querySelectorAll('[data-tags]').forEach((item) => {
        item.hidden = tag !== '' && !item.dataset.tags.split(' ').includes(tag);
      });
    };
    nav.addEventListener('click', (e) => {
      const b = e.target.closest('[data-filter]');
      if (!b) return;
      apply(b.dataset.filter);
      history.replaceState({}, '', b.dataset.filter ? '#' + b.dataset.filter : location.pathname + location.search);
    });
    const initial = location.hash.slice(1);
    if (initial && nav.querySelector('[data-filter="' + CSS.escape(initial) + '"]')) apply(initial);
  });

  /* ---------- Wine quiz ---------- */
  document.querySelectorAll('[data-quiz]').forEach((quiz) => {
    const steps = [...quiz.querySelectorAll('[data-quiz-step]')];
    const results = [...quiz.querySelectorAll('[data-quiz-result]')];
    let votes = {};
    let current = 0;
    const show = (el) => { el.hidden = false; el.classList.remove('is-in'); requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('is-in'))); };
    const reset = () => {
      votes = {};
      current = 0;
      results.forEach((r) => { r.hidden = true; });
      steps.forEach((s, i) => { s.hidden = i !== 0; });
      if (steps[0]) show(steps[0]);
    };
    quiz.classList.add('quiz--js');
    if (steps[0]) steps[0].classList.add('is-in');
    quiz.addEventListener('click', (e) => {
      const answer = e.target.closest('[data-quiz-answer]');
      if (answer) {
        const key = answer.dataset.quizAnswer;
        votes[key] = (votes[key] || 0) + 1;
        steps[current].hidden = true;
        current += 1;
        if (current < steps.length) { show(steps[current]); return; }
        const winner = Object.keys(votes).sort((a, b) => votes[b] - votes[a] || a - b)[0];
        const result = results.find((r) => r.dataset.quizResult === winner) || results[0];
        if (result) show(result);
        return;
      }
      if (e.target.closest('[data-quiz-restart]')) reset();
    });
  });

  /* ---------- Reveal on scroll ---------- */
  if (!reduceMotion && 'IntersectionObserver' in window) {
    const targets = document.querySelectorAll('.columns .col, .wine, .product-grid__item, .product-carousel, .quiz__inner, .featured-product__inner, .footer-newsletter');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach((el, i) => {
      el.classList.add('reveal');
      el.style.setProperty('--reveal-delay', (i % 4) * 90 + 'ms');
      io.observe(el);
    });
  }

  /* ---------- Count-up numbers ---------- */
  const counters = [...document.querySelectorAll('[data-count-to]')].filter((el) => /^\d+$/.test(el.dataset.countTo));
  if (counters.length && !reduceMotion && 'IntersectionObserver' in window) {
    const run = (el) => {
      const target = parseInt(el.dataset.countTo, 10);
      const start = target >= 1000 ? target - 30 : 0;
      const t0 = performance.now();
      const dur = 1400;
      const step = (now) => {
        const p = Math.min(1, (now - t0) / dur);
        const eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(start + (target - start) * eased);
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    const co = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { run(e.target); co.unobserve(e.target); } });
    }, { threshold: 0.6 });
    counters.forEach((el) => co.observe(el));
  }

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    const input = btn.closest('[data-qty]').querySelector('input');
    const next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qtyStep, 10));
    input.value = next;
  });

  /* ---------- Wine list category nav ---------- */
  const wineNav = document.querySelector('[data-wine-nav]');
  if (wineNav && 'IntersectionObserver' in window) {
    const links = [...wineNav.querySelectorAll('[data-wine-nav-link]')];
    const groups = links.map((l) => document.getElementById(l.dataset.wineNavLink)).filter(Boolean);
    const setActive = (id) => links.forEach((l) => l.classList.toggle('is-active', l.dataset.wineNavLink === id));
    const gio = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) setActive(en.target.id); });
    }, { rootMargin: '-45% 0px -50% 0px' });
    groups.forEach((g) => gio.observe(g));
    if (groups[0]) setActive(groups[0].id);
  }

  /* ---------- Event: add to calendar (.ics) ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ics]');
    if (!btn) return;
    const d = btn.dataset;
    const ymd = (d.date || '').replace(/-/g, '');
    if (ymd.length !== 8) return;
    const times = (d.time || '').match(/(\d{1,2})[:.](\d{2})/g) || [];
    const hm = (t) => t.replace('.', ':').split(':').map((n) => n.padStart(2, '0')).join('') + '00';
    const esc = (t) => (t || '').replace(/([,;\\])/g, '\\$1').replace(/\n/g, '\\n');
    let start;
    let end;
    if (times.length) {
      start = 'DTSTART;TZID=Europe/Vienna:' + ymd + 'T' + hm(times[0]);
      let endT = times[1] ? hm(times[1]) : null;
      if (!endT) { const [h, m] = times[0].replace('.', ':').split(':').map(Number); endT = String(Math.min(h + 3, 23)).padStart(2, '0') + String(m).padStart(2, '0') + '00'; }
      end = 'DTEND;TZID=Europe/Vienna:' + ymd + 'T' + endT;
    } else {
      const next = new Date(d.date + 'T12:00:00');
      next.setDate(next.getDate() + 1);
      start = 'DTSTART;VALUE=DATE:' + ymd;
      end = 'DTEND;VALUE=DATE:' + next.toISOString().slice(0, 10).replace(/-/g, '');
    }
    const ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Biowein Lenhart//Termine//DE', 'BEGIN:VEVENT',
      'UID:' + ymd + '-' + Math.random().toString(36).slice(2) + '@biowein-lenhart.at',
      'DTSTAMP:' + new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d+Z$/, 'Z'),
      start, end, 'SUMMARY:' + esc(d.title), 'LOCATION:' + esc(d.location), 'DESCRIPTION:' + esc(d.description),
      'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
    const url = URL.createObjectURL(new Blob([ics], { type: 'text/calendar;charset=utf-8' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = (d.title || 'termin').toLowerCase().replace(/[^a-z0-9äöüß]+/gi, '-') + '.ics';
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  });

  /* ---------- Tasting offers → prefill request form ---------- */
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-offer]');
    if (!link) return;
    const form = document.getElementById('TastingForm');
    const select = form && form.querySelector('[data-offer-select]');
    if (!select) return;
    const value = link.dataset.offer;
    if ([...select.options].some((o) => o.value === value)) select.value = value;
    const ortMap = { 'Ab Hof verkosten': 'abhof', 'Wein kommt zu dir': 'vorort' };
    const ort = ortMap[value] && form.querySelector('[data-ort="' + ortMap[value] + '"]');
    if (ort) ort.checked = true;
    if (value === 'Wein & Jause') {
      const j = form.querySelector('[data-jause]');
      if (j) j.checked = true;
      select.value = select.options[0].value;
    }
    form.classList.remove('is-flash');
    requestAnimationFrame(() => form.classList.add('is-flash'));
  });

  /* ---------- Ab-Hof live open badge (Europe/Vienna) ---------- */
  // Ab-Hof days that are closed (holidays), as YYYY-MM-DD: the badge skips them.
  const abHofClosed = ['2026-10-27'];
  const viennaDate = (d) => new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Vienna', year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
  document.querySelectorAll('[data-open-badge]').forEach((el) => {
    const day = +el.dataset.day, from = +el.dataset.from, to = +el.dataset.to;
    const compact = el.hasAttribute('data-compact');
    const days = compact ? ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'] : ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
    const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Vienna', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
    const get = (t) => (parts.find((p) => p.type === t) || {}).value;
    const wd = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(get('weekday'));
    const mins = +get('hour') * 60 + +get('minute');
    const hours = from + '–' + to + ' Uhr';
    const text = el.querySelector('[data-open-text]');
    const closedToday = abHofClosed.includes(viennaDate(new Date()));
    if (wd === day && !closedToday && mins >= from * 60 && mins < to * 60) {
      el.classList.add('is-open');
      text.textContent = compact ? 'Jetzt geöffnet · bis ' + to + ' Uhr' : 'Jetzt geöffnet – bis ' + to + ':00 Uhr';
    } else {
      let diff = (day - wd + 7) % 7;
      if (diff === 0 && (mins >= to * 60 || closedToday)) diff = 7;
      while (abHofClosed.includes(viennaDate(new Date(Date.now() + diff * 864e5)))) diff += 7;
      if (diff === 0) {
        el.classList.add('is-today');
        text.textContent = (compact ? 'Heute Ab Hof · ' : 'Heute Ab-Hof-Tag: ') + hours;
      } else {
        const next = new Date(Date.now() + diff * 864e5);
        const date = next.toLocaleDateString('de-AT', { timeZone: 'Europe/Vienna', day: 'numeric', month: compact ? 'short' : 'long' });
        const label = diff === 1 ? 'Morgen' : days[day] + ', ' + date;
        text.textContent = (compact ? 'Nächster Ab-Hof-Tag: ' : 'Nächster Ab-Hof-Tag: ') + label + (compact ? ' · ' : ', ') + hours;
      }
    }
    el.hidden = false;
  });

  /* ---------- Contact hub: topic preselect, jump to result ---------- */
  const contactForm = document.getElementById('ContactForm');
  if (contactForm) {
    const pickTopic = (value) => {
      if (!value) return;
      const v = value.toLowerCase();
      const radio = [...contactForm.querySelectorAll('input[name="contact[Thema]"]')]
        .find((r) => r.value.toLowerCase().startsWith(v) || v.startsWith(r.value.toLowerCase().split(' ')[0]));
      if (radio) radio.checked = true;
    };
    pickTopic(new URLSearchParams(location.search).get('thema'));
    document.querySelectorAll('[data-pick-topic]').forEach((btn) => {
      btn.addEventListener('click', () => {
        pickTopic(btn.dataset.pickTopic);
        setTimeout(() => { const m = document.getElementById('ContactMessage'); if (m) m.focus({ preventScroll: true }); }, 400);
      });
    });
    const result = document.querySelector('[data-scroll-here]');
    if (result) setTimeout(() => result.scrollIntoView({ behavior: 'smooth', block: 'start' }), 150);
  }

  /* ---------- Gift card: send to recipient ---------- */
  document.querySelectorAll('[data-gift-recipient]').forEach((box) => {
    const toggle = box.querySelector('[data-gift-toggle]');
    const fields = box.querySelector('[data-gift-fields]');
    toggle.addEventListener('change', () => {
      fields.disabled = !toggle.checked;
      fields.hidden = !toggle.checked;
      if (toggle.checked) fields.querySelector('input[type="email"]').focus();
    });
  });

  /* ---------- Wildling Wermut: white → black stage ---------- */
  const wm = document.querySelector('[data-wm]');
  if (wm) {
    const stage = wm.querySelector('[data-wm-stage]');
    const night = wm.querySelector('[data-wm-night]');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const phone = window.matchMedia('(max-width: 899px)');
    let braked = false;
    let lastE = null;
    const block = (ev) => ev.preventDefault();
    // Hold the scroll position (also stops a swipe's momentum) without touching overflow, so the sticky stage stays intact.
    const lockScroll = (y, ms) => {
      const until = performance.now() + ms;
      window.addEventListener('touchmove', block, { passive: false });
      window.addEventListener('wheel', block, { passive: false });
      const hold = () => {
        if (Math.abs(window.scrollY - y) > 1) window.scrollTo({ top: y, behavior: 'instant' });
        if (performance.now() < until) requestAnimationFrame(hold);
        else {
          window.removeEventListener('touchmove', block);
          window.removeEventListener('wheel', block);
        }
      };
      hold();
    };
    let ticking = false;
    const update = () => {
      ticking = false;
      const total = stage.offsetHeight - window.innerHeight;
      const p = reduce ? 1 : Math.min(1, Math.max(0, -stage.getBoundingClientRect().top / Math.max(total, 1)));
      const e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      stage.style.setProperty('--e', e.toFixed(4));
      const bang = e > 0.5;
      // Phones: hold the page for a moment when the words pop in, so a fast swipe can't skip them.
      if (bang && lastE !== null && lastE <= 0.5 && !braked && !reduce && phone.matches) {
        braked = true;
        lockScroll(stage.getBoundingClientRect().top + window.scrollY + total * 0.62, 900);
      }
      if (e < 0.2) braked = false;
      lastE = e;
      stage.classList.toggle('is-bang', bang);
      document.body.classList.toggle('is-night', e > 0.55 && night.getBoundingClientRect().bottom > 90);
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) en.target.classList.add('is-in'); });
    }, { threshold: 0.2 });
    wm.querySelectorAll('.wm__chapter, .wm-reveal').forEach((c) => io.observe(c));

    // Scroll-driven extras: ghosts meeting, flying goose, marquee skew.
    const meet = wm.querySelector('[data-wm-meet]');
    const flyZone = wm.querySelector('[data-wm-fly-zone]');
    const fly = wm.querySelector('[data-wm-fly]');
    const marquee = wm.querySelector('[data-wm-marquee]');
    const clamp01 = (v) => Math.min(1, Math.max(0, v));
    let lastY = window.scrollY;
    let skew = 0;
    let extrasTicking = false;
    const updateExtras = () => {
      extrasTicking = false;
      const vh = window.innerHeight;
      if (meet) {
        const r = meet.getBoundingClientRect();
        // Words start moving as the block scrolls in and have met once it is in the upper third.
        meet.style.setProperty('--p', clamp01((vh - r.top) / (vh * 0.7)).toFixed(4));
      }
      if (fly && flyZone) {
        const r = flyZone.getBoundingClientRect();
        fly.style.setProperty('--fx', clamp01((vh - r.top) / (vh + r.height)).toFixed(4));
      }
      if (marquee) {
        const y = window.scrollY;
        skew = Math.max(-14, Math.min(14, skew * 0.8 + (y - lastY) * 0.25));
        lastY = y;
        marquee.style.setProperty('--skew', `${(-skew).toFixed(2)}deg`);
        if (Math.abs(skew) > 0.05) { extrasTicking = true; requestAnimationFrame(updateExtras); }
      }
    };
    if (!reduce) {
      const onExtras = () => { if (!extrasTicking) { extrasTicking = true; requestAnimationFrame(updateExtras); } };
      window.addEventListener('scroll', onExtras, { passive: true });
      window.addEventListener('resize', onExtras);
      updateExtras();
    }

    // The hare hops from the buy section into the cart icon after "In den Warenkorb".
    const hare = wm.querySelector('.wm__hare');
    if (hare && !reduce) {
      wm.addEventListener('cart:added', () => {
        const target = [...document.querySelectorAll('.site-header__cart, a[href$="/cart"]')]
          .find((el) => el.getBoundingClientRect().width > 0);
        if (!target) return;
        const from = hare.getBoundingClientRect();
        const to = target.getBoundingClientRect();
        const size = Math.min(from.width, 160);
        const x0 = from.left + from.width / 2 - size / 2;
        const y0 = from.top + from.height / 2 - size / 2;
        const dx = to.left + to.width / 2 - size / 2 - x0;
        const dy = to.top + to.height / 2 - size / 2 - y0;
        // Arc upwards, but keep the peak on screen.
        const lift = Math.max(0, Math.min(260, Math.abs(dy) * 0.5 + 120, y0 + dy * 0.5 - 10));
        const clone = hare.cloneNode();
        clone.classList.remove('wm-reveal');
        clone.classList.add('wm__hare-fly');
        clone.removeAttribute('loading');
        Object.assign(clone.style, { left: `${x0}px`, top: `${y0}px`, width: `${size}px` });
        document.body.appendChild(clone);
        const hop = clone.animate([
          { transform: 'translate(0, 0) scale(1) rotate(0deg)' },
          { transform: `translate(${dx * 0.15}px, 30px) scale(1.05, .8) rotate(0deg)`, offset: 0.12 },
          { transform: `translate(${dx * 0.5}px, ${dy * 0.5 - lift}px) scale(.8) rotate(-25deg)`, offset: 0.55 },
          { transform: `translate(${dx}px, ${dy}px) scale(.12) rotate(-60deg)`, opacity: 0.6 },
        ], { duration: 1000, easing: 'cubic-bezier(.3, .1, .4, 1)' });
        hop.onfinish = () => {
          clone.remove();
          target.animate([
            { transform: 'scale(1)' }, { transform: 'scale(1.35) rotate(-10deg)' }, { transform: 'scale(.9) rotate(8deg)' }, { transform: 'scale(1)' },
          ], { duration: 450, easing: 'ease-out' });
        };
      });
    }
  }

  /* ---------- Weinrad ---------- */
  document.querySelectorAll('[data-wheel]').forEach((wheel) => {
    const disc = wheel.querySelector('[data-wheel-disc]');
    const btn = wheel.querySelector('[data-wheel-spin]');
    const result = wheel.querySelector('[data-wheel-result]');
    const slot = wheel.querySelector('[data-wheel-prize-slot]');
    const n = parseInt(disc.dataset.segments, 10) || 1;
    const seg = 360 / n;
    const key = wheel.dataset.storageKey;
    const store = {
      get() { try { return localStorage.getItem(key); } catch (e) { return null; } },
      set(v) { try { localStorage.setItem(key, v); } catch (e) { /* private mode */ } },
    };
    const angleFor = (i, turns) => turns * 360 + (360 - (i * seg + seg / 2));
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    // Put the prize into the cart (once) and apply its discount code for this session
    const claim = async (tpl) => {
      const status = slot.querySelector('[data-wheel-status]');
      const variant = parseInt(tpl.dataset.variant, 10);
      try {
        let cart = await (await fetch(root + 'cart.js')).json();
        if (variant && !cart.items.some((it) => it.variant_id === variant)) {
          const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variant, quantity: 1 }] }) });
          if (!res.ok) throw new Error('add failed');
          cart = await (await fetch(root + 'cart.js')).json();
        }
        await fetch(root + 'discount/' + encodeURIComponent(tpl.dataset.code), { credentials: 'same-origin' });
        if (typeof updateCount === 'function') updateCount(cart.item_count);
        if (typeof renderShippingProgress === 'function') renderShippingProgress(cart);
        if (status) { status.textContent = '✓ Liegt gratis in deinem Warenkorb'; status.classList.add('is-done'); }
      } catch (e) {
        if (status) status.textContent = 'Leg die Flasche einfach selbst in den Warenkorb – der Code wird beim Einlösen abgezogen.';
      }
    };
    const show = (i) => {
      const tpl = wheel.querySelector('[data-wheel-prize="' + i + '"]');
      if (!tpl) return;
      slot.innerHTML = '';
      slot.appendChild(tpl.content.cloneNode(true));
      result.hidden = false;
      btn.disabled = true;
      btn.textContent = '✓';
      slot.querySelectorAll('[data-wheel-copy]').forEach((c) => c.addEventListener('click', () => {
        const done = () => { c.textContent = 'Kopiert ✓'; c.classList.add('is-done'); };
        if (navigator.clipboard) navigator.clipboard.writeText(c.dataset.wheelCopy).then(done); else done();
      }));
      claim(tpl);
    };
    const saved = store.get();
    if (saved !== null && saved !== '' && !isNaN(saved)) {
      const i = parseInt(saved, 10);
      disc.style.transition = 'none';
      disc.style.transform = 'rotate(' + angleFor(i, 0) + 'deg)';
      show(i);
      return;
    }
    btn.addEventListener('click', () => {
      if (btn.disabled) return;
      btn.disabled = true;
      const i = Math.floor(Math.random() * n);
      const jitter = (Math.random() - 0.5) * (seg - 10);
      disc.style.transform = 'rotate(' + (angleFor(i, 6) + jitter) + 'deg)';
      store.set(String(i));
      const finish = () => { show(i); result.scrollIntoView({ behavior: 'smooth', block: 'center' }); };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
      else disc.addEventListener('transitionend', finish, { once: true });
    });
  });

  /* ---------- Variant price update ---------- */
  const variantSelect = document.getElementById('ProductVariant');
  if (variantSelect) {
    variantSelect.addEventListener('change', () => {
      const url = new URL(location.href);
      url.searchParams.set('variant', variantSelect.value);
      history.replaceState({}, '', url);
      const label = variantSelect.selectedOptions[0].textContent.split('–').pop().trim();
      const price = document.querySelector('[data-product-price]');
      if (price && label) price.textContent = label;
    });
  }
})();
